module.exports = __webpack_public_path__ + "img/voice_title_sel.7adb63a8.png";